/**
 * Gets the max height from a list of ResizeObserver entries, returns undefined if it can't calculate it
 */
export function getObservedEntriesMaxHeight(entries: ResizeObserverEntry[]): string | undefined {
  const maxHeight = entries.reduce((acc, entry) => Math.max(acc + entry.contentRect.height), 0);
  if (maxHeight > 0) {
    return maxHeight + 'px';
  }
  return;
}
